import styled from "styled-components";

export const StyledAttachment = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 10px;

  &.attachment-box {
    color: ${({ theme }) => theme.palette.text.secondary};
    border-radius: 8px;
    border: 1px solid rgba(234, 236, 239, 1);
    padding: 12px;
  }
`;